// For an exhaustive list please check https://www.prisma.io/docs/reference/api-reference/error-reference#error-codes
export enum PrismaErrorCode {
  RECORD_SEARCHED_DOES_NOT_EXIST = 'P2001',
  UNIQUE_CONSTRAINT_FAILED = 'P2002',
  FOREIGN_KEY_CONSTRAINT_FAILED = 'P2003',
  CONSTRAINT_FAILED_ON_DATABASE = 'P2004',
  RELATED_RECORD_NOT_FOUND = 'P2015',
  INCONSISTENT_COLUMN_DATA = 'P2023',
  REQUIRED_RECORD_DEPENDENCY_NOT_FOUND = 'P2025',
}
